import { useEffect, useState } from "react";
import { FileSpreadsheet, FileText, Loader2, Paperclip } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const saveBlob = async (url, name) => {
  const { data } = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 30000);
};

const DlBtn = ({ onClick, icon: Icon, label, testid }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await onClick(); } catch (e) { toast.error("Gagal mengunduh file"); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={testid}
      className="inline-flex items-center gap-1.5 h-10 px-4 rounded-full border border-emerald-800 text-emerald-800 text-sm font-bold hover:bg-emerald-50 disabled:opacity-60">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />}{label}
    </button>
  );
};

export const BookkeepingButtons = ({ contractId, code, testid = "book" }) => (
  <div className="flex flex-wrap gap-2">
    <DlBtn icon={FileSpreadsheet} label="Unduh Excel" testid={`${testid}-xlsx-btn`} onClick={() => saveBlob(`/profit/contracts/${contractId}/bookkeeping.xlsx`, `Pembukuan-${code || "kebun"}.xlsx`)} />
    <DlBtn icon={FileText} label="Unduh PDF" testid={`${testid}-pdf-btn`} onClick={() => saveBlob(`/profit/contracts/${contractId}/bookkeeping.pdf`, `Pembukuan-${code || "kebun"}.pdf`)} />
  </div>
);

const ArchiveLink = ({ n, testid }) => {
  const dl = () => saveBlob(`/agreement-archives/${n.archiveId}/pdf`, `${n.archiveCode}.pdf`).catch(() => toast.error("Gagal mengunduh arsip"));
  return <button type="button" onClick={dl} className="inline-flex items-center gap-1 text-emerald-800 underline font-semibold" data-testid={testid}><FileText className="h-3 w-3" />Unduh arsip PDF</button>;
};

export const ProofLink = ({ n, testid }) => {
  if (n.type === "ARCHIVE_READY" && n.archiveId) return <ArchiveLink n={n} testid={testid.replace("proof", "archive")} />;
  if (n.type !== "PAYOUT_PAID" || !n.payoutId) return null;
  const open = async () => {
    const w = window.open("", "_blank");
    try {
      const { data } = await api.get(`/profit/payouts/${n.payoutId}/proof`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      if (w) w.location.href = url; else window.location.href = url;
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) { if (w) w.close(); toast.error("Bukti pembayaran tidak dapat dibuka"); }
  };
  return <button type="button" onClick={open} className="inline-flex items-center gap-1 text-emerald-800 underline font-semibold" data-testid={testid}><Paperclip className="h-3 w-3" />Lihat bukti</button>;
};

export const MyBookkeeping = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/profit/my-bookkeeping").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (!items?.length) return null;
  return (
    <section className="mb-6 rounded-xl border bg-white p-4 sm:p-5" data-testid="my-bookkeeping">
      <p className="font-bold text-slate-900">Data Pembukuan Bagi Hasil</p>
      <p className="text-xs text-slate-500 mb-3">Unduh penjualan, biaya, dan pembayaran kebun Anda untuk arsip, akuntan, atau pajak.</p>
      <ul className="divide-y">{items.map((k) => (
        <li key={k.contractId} className="flex flex-col gap-2 py-2.5 sm:flex-row sm:items-center sm:justify-between" data-testid={`my-book-${k.contractId}`}>
          <span className="text-sm font-semibold text-slate-800">{k.projectCode} · {k.projectName}</span>
          <BookkeepingButtons contractId={k.contractId} code={k.projectCode} testid={`my-book-${k.contractId}`} />
        </li>))}</ul>
    </section>
  );
};
